import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, API_ENDPOINTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';

const useCustomerAccreditations = query => {
  const queryString = `${API_ENDPOINTS.CUSTOMER_ACCREDITATIONS}?AccreditationIds=${query.eventivalAccreditations.join(
    '%2C'
  )}&TicketTypeIds=${query.ticketingSystemTypes.join('%2C')}&Term=${query.term}&PageSize=${query.pageSize}&Page=${
    query.page
  }&RetrieveAll=${query.retrieveAll}&IncludeCount=${query.includeCount}&SortBy=${query.sortBy}&SortOrder=${
    query.sortOrder
  }&Includes=${query.includes}`;
  const [path, setPath] = useState(queryString);
  const { t } = useTranslation(LOCALIZATION_PAGES.ACCREDITATION_LIST);
  const { showNotification } = useRoot();
  const [{ result: customerAccreditations, loading, error }, getAccreditations] = useApi(path);

  useEffect(() => {
    setPath(queryString);
  }, [queryString]);

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('fetching_accreditations_fail'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  return [{ customerAccreditations, loading, error }, getAccreditations];
};

export default useCustomerAccreditations;
